import IntroductionComponent from "../components/introduction";
import StreamComponent from "../components/stream";
import ProductsComponent from "../components/products";
import ArticlesComponent from "../components/articles";

export const IntroductionSection = {
  key: "component--introduction-section",
  component: IntroductionComponent,
};

export const StreamSection = {
  key: "component--stream-section",
  component: StreamComponent,
};

export const ProductsSection = {
  key: "component--products-section",
  component: ProductsComponent,
};

export const ArticlesSection = {
  key: "component--articles-section",
  component: ArticlesComponent,
};

export const DatoKeyValuesMap = [
  IntroductionSection,
  StreamSection,
  ProductsSection,
  ArticlesSection,
];
